import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import bannerImg from '../assets/images/banner.png';

const Concierge = () => {
  return (
    <div className="service-detail-page">
      
      {/* INJECTED STYLES FOR MOBILE RESPONSIVENESS */}
      <style>
        {`
          /* --- REMOVE GLOBAL HERO ARROW JUST FOR THIS PAGE --- */
          .service-hero::after {
            display: none !important;
          }

          /* --- PREMIUM MOBILE RESPONSIVE FIXES --- */
          @media (max-width: 992px) {
            .service-text-grid { grid-template-columns: 1fr !important; gap: 3rem !important; }
            .process-steps { grid-template-columns: 1fr !important; gap: 2rem !important; }
          }

          @media (max-width: 768px) {
            /* Hero adjustments to prevent overlap with header */
            .service-hero { padding: 13rem 1.5rem 5rem 1.5rem !important; }
            .service-hero h1 { font-size: 2.5rem !important; line-height: 1.2 !important; }
            .service-hero p.subtitle { font-size: 1.1rem !important; }

            /* Enforce container boundaries */
            .container { padding-left: 1.5rem !important; padding-right: 1.5rem !important; }

            /* Spacing fixes */
            .service-main-content { padding-top: 4rem !important; padding-bottom: 4rem !important; }
            .service-process-section { padding-top: 4rem !important; padding-bottom: 4rem !important; }
            
            /* Fix CTA layout overlapping screen edges */
            .sleek-cta-banner-override { flex-direction: column !important; text-align: center !important; padding: 3rem 1.5rem !important; }
            .sleek-cta-banner-override > div { min-width: 100% !important; text-align: center !important; }
            .sleek-cta-banner-override p { margin: 0 auto !important; }
          }
        `}
      </style>

      {/* 1. UNIFIED HERO */}
      <section className="service-hero">
        <div className="container text-center">
          <h1>Concierge Services</h1>
          <p className="subtitle">
            A welcoming, customer-focused approach that prioritises both safety and community.
          </p>
        </div>
      </section>

      {/* 2. MAIN CONTENT & SIDEBAR */}
      <section className="service-main-content container" style={{ paddingTop: '6rem', paddingBottom: '6rem' }}>
        <div className="service-text-grid">
          
          {/* Left Column: Description */}
          <div className="service-description">
            <h2 style={{ marginTop: 0 }}>Welcoming & Secure Front-of-House</h2>
            <p>
              Our concierge teams support student accommodation, residential and commercial environments by providing a professional front-of-house presence that balances customer service with operational oversight. Acting as the first point of contact for residents, visitors and staff, they help create positive experiences whilst maintaining the safety and security of the building.
            </p>
            <p>
              Beyond reception duties, our personnel manage visitor access, support building operations and maintain strong situational awareness throughout their shift. By combining service excellence with security awareness, they help ensure environments remain safe, organised and professionally managed without detracting from the experience of those who use them.
            </p>

            <h3>Core Capabilities</h3>
            <ul className="custom-bullet-list">
              <li>Front-of-house and reception services</li>
              <li>Visitor management and access control</li>
              <li>Building management and health & safety support</li>
              <li>Mailroom and delivery management</li>
              <li>Contractor and visitor coordination</li>
              <li>Conflict management and welfare support</li>
              <li>Incident reporting and escalation</li>
              <li>Emergency response assistance</li>
            </ul>
          </div>

          {/* Right Column: Premium Contact Sidebar */}
          <aside className="service-sidebar" style={{ backgroundColor: 'var(--color-primary-navy)', color: 'var(--color-white)', padding: '3rem 2.5rem', borderRadius: '12px', boxShadow: '0 20px 40px rgba(0,0,0,0.15)', height: 'fit-content', border: 'none' }}>
            <h3 style={{ color: 'var(--color-white)', marginBottom: '1rem', borderBottom: '1px solid rgba(255,255,255,0.1)', paddingBottom: '1rem' }}>Enhance Your Reception</h3>
            <p style={{ fontSize: '0.95rem', color: 'var(--color-secondary-light)', lineHeight: '1.6', marginBottom: '2rem' }}>
              Speak directly with our team to discuss tailored concierge and front-of-house security for your premises.
            </p>
            <div className="sidebar-contact" style={{ borderTop: 'none', paddingTop: 0, marginTop: 0 }}>
              <span style={{ fontSize: '0.85rem', fontWeight: '700', letterSpacing: '2px', textTransform: 'uppercase', color: 'var(--color-secondary-grey)', display: 'block', marginBottom: '0.5rem' }}>Operations Desk</span>
              <div className="phone-number" style={{ fontFamily: 'var(--font-heading)', fontSize: '1.8rem', fontWeight: '800', color: 'var(--color-white)', margin: '0 0 2rem 0' }}>01270 446302</div>
              <Link to="/contact" className="btn btn-pill w-100 text-center" style={{ backgroundColor: 'var(--color-white)', color: 'var(--color-primary-navy)', fontWeight: '700', padding: '1rem', fontSize: '0.95rem', boxShadow: '0 8px 20px rgba(0,0,0,0.1)' }}>
                Contact Us
              </Link>
            </div>
          </aside>

        </div>
      </section>

      {/* 3. PROCESS SECTION */}
      <section className="service-process-section bg-navy" style={{ paddingTop: '6rem', paddingBottom: '8rem' }}>
        <div className="container">
          <div className="text-center" style={{ marginBottom: '4rem' }}>
            <h2 style={{ color: 'var(--color-white)' }}>Our Concierge Approach</h2>
          </div>
          <div className="process-steps">
            <div className="step-card">
              <h4>Understand</h4>
              <p>Every building operates differently. We take the time to understand your environment, occupiers and operational priorities.</p>
            </div>
            <div className="step-card">
              <h4>Integrate</h4>
              <p>Acting as an extension of your team, our concierge personnel support residents, visitors and staff while contributing to the smooth operation of the building.</p>
            </div>
            <div className="step-card">
              <h4>Support</h4>
              <p>Combining customer service, security awareness and operational oversight, we help create safe, welcoming and professionally managed environments.</p>
            </div>
          </div>
        </div>
      </section>

      {/* 4. SLEEK FLOATING CTA BANNER */}
      <section style={{ backgroundColor: 'var(--color-white)', paddingTop: '4rem', paddingBottom: '6rem' }}>
        <div className="container">
          <div 
            className="sleek-cta-banner-override"
            style={{ 
            backgroundImage: `linear-gradient(to right, rgba(23, 44, 79, 0.95), rgba(23, 44, 79, 0.8)), url(${bannerImg})`,
            borderRadius: '16px',
            padding: '3rem 4rem',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            boxShadow: '0 20px 40px rgba(0,0,0,0.15)',
            gap: '2rem',
            flexWrap: 'wrap',
            position: 'relative',
            overflow: 'hidden'
          }}>

            <div style={{ textAlign: 'left', flex: '1', position: 'relative', zIndex: 2, minWidth: '300px' }}>
              <h2 style={{ color: 'var(--color-white)', marginBottom: '0.5rem', fontSize: '2.1rem', letterSpacing: '-0.5px' }}>Uncompromising Security Solutions</h2>
              <p style={{ color: 'var(--color-secondary-light)', fontSize: '1rem', margin: 0, maxWidth: '600px', lineHeight: '1.6' }}>
                Discover how our highly trained personnel can deliver bespoke security solutions tailored to your organisation.
              </p>
            </div>
            
            <div style={{ position: 'relative', zIndex: 2, flexShrink: 0 }}>
              <Link to="/contact" className="btn btn-pill" style={{ 
                backgroundColor: 'var(--color-white)', 
                color: 'var(--color-primary-navy)', 
                fontWeight: '700', 
                padding: '1rem 2.5rem', 
                fontSize: '0.95rem',
                boxShadow: '0 8px 20px rgba(0,0,0,0.1)'
              }}>
                Contact Us
              </Link>
            </div>
          </div>
        </div>
      </section>

    </div>
  );
};

export default Concierge;